import { Link as RouterLink } from 'react-router-dom'
import {
    Box,
    Flex,
    Text,
    IconButton,
    Image,
    Stack,
    Collapse,
    Icon,
    Link,
    Popover,
    PopoverTrigger,
    PopoverContent,
    useColorModeValue,
    useDisclosure,
} from '@chakra-ui/react';
import {
    HamburgerIcon,
    CloseIcon,
    ChevronDownIcon,
    ChevronRightIcon,
} from '@chakra-ui/icons';
import { useState } from 'react';

export default function WithSubnavigation() {
    const { isOpen, onToggle } = useDisclosure();

    // const [isMobileNav, setMobileNav] = useState(true)

    return (
        <Box>
            <Flex
                bg={useColorModeValue('white', 'gray.800')}
                color={useColorModeValue('gray.600', 'white')}
                minH={'60px'}
                py={{ base: 2 }}
                px={{ base: 4 }}
                borderBottom={1}
                borderStyle={'solid'}
                borderColor={useColorModeValue('gray.200', 'gray.900')}
                align={'center'}>
                <Flex
                    flex={{ base: 1, md: 'auto' }}
                    ml={{ base: -2 }}
                    display={{ base: 'flex', md: 'none' }}
                    justify={'start'}>
                    <IconButton
                        onClick={onToggle}
                        icon={
                            isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
                        }
                        variant={'ghost'}
                        aria-label={'Toggle Navigation'}
                    />
                </Flex>
                <Flex display={{ base: 'none', md: 'flex' }} ml={5}>
                    <DesktopNav />
                </Flex>
                <Flex flex={{ base: 1 }} justify={'end'}>
                    <Image
                        mr={{ sm: 0, md: 5, lg: 5 }}
                        className='body-logo'
                        borderRadius={'75'}
                        boxSize='125'
                        objectFit='fill'
                        src='../Minimal_Mountain_Logo_4.png'
                        alt='Body in Mind' />

                </Flex>
            </Flex>

            <Collapse in={isOpen} animateOpacity>
                <MobileNav onClick={onToggle} />
            </Collapse>
        </Box>
    );
}

const DesktopNav = () => {
    const linkColor = useColorModeValue('gray.600', 'gray.200');
    const linkHoverColor = useColorModeValue('gray.800', 'white');
    const popoverContentBgColor = useColorModeValue('white', 'gray.800');

    return (
        <Stack direction={'row'} spacing={4}>
            {NAV_ITEMS.map((navItem) => (
                <Box key={navItem.label}>
                    <Popover trigger={'hover'} placement={'bottom-start'}>
                        <PopoverTrigger>
                            <Link
                                as={RouterLink}
                                p={2}
                                to={navItem.to ?? '#'}
                                fontSize={'sm'}
                                fontWeight={500}
                                color={linkColor}
                                _hover={{
                                    textDecoration: 'none',
                                    color: linkHoverColor,
                                }}>
                                {navItem.label}
                            </Link>
                        </PopoverTrigger>

                        {navItem.children && (
                            <PopoverContent
                                border={0}
                                boxShadow={'xl'}
                                bg={popoverContentBgColor}
                                p={4}
                                rounded={'xl'}
                                minW={'sm'}>
                                <Stack>
                                    {navItem.children.map((child) => (
                                        <DesktopSubNav key={child.label} {...child} />
                                    ))}
                                </Stack>
                            </PopoverContent>
                        )}
                    </Popover>
                </Box>
            ))}
        </Stack>
    );
};

const DesktopSubNav = ({ label, href, subLabel }) => {
    return (
        <Link
            href={href}
            role={'group'}
            display={'block'}
            p={2}
            rounded={'md'}
            _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}>
            <Stack direction={'row'} align={'center'}>
                <Box>
                    <Text
                        transition={'all .3s ease'}
                        _groupHover={{ color: 'pink.400' }}
                        fontWeight={500}>
                        {label}
                    </Text>
                    <Text fontSize={'sm'}>{subLabel}</Text>
                </Box>
                <Flex
                    transition={'all .3s ease'}
                    transform={'translateX(-10px)'}
                    opacity={0}
                    _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
                    justify={'flex-end'}
                    align={'center'}
                    flex={1}>
                    <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} />
                </Flex>
            </Stack>
        </Link>
    );
};

const MobileNav = (props) => {
    
    return (
        <Stack

            bg={useColorModeValue('white', 'gray.800')}
            p={4}
            display={{ md: 'none' }}>
            {NAV_ITEMS.map((navItem) => (
                <MobileNavItem key={navItem.label} {...navItem} onClick={props.onClick} />
            ))}
        </Stack>
    );
};

const MobileNavItem = (props) => {

    const { isOpen, onToggle } = useDisclosure();

    return (
        <Stack spacing={4} onClick={props.onClick}>
            <Flex
                
                as={RouterLink}
                p={2}
                to={props.to ?? '#'}
                  fontSize={'sm'}
                fontWeight={600}
                align={'center'}
                color={useColorModeValue('gray.600', 'gray.200')}
            >
                <Text
                
                    fontWeight={600}
                    color={useColorModeValue('gray.600', 'gray.200')}>
                    {props.label}
                </Text>
                {/* <Link as={RouterLink}
                    p={2}
                    to={to ?? '#'}
                    //   fontSize={'sm'}
                    fontWeight={600}
                    align={'center'}
                    color={useColorModeValue('gray.600', 'gray.200')}
                > */}
                {/* {label} */}
                {/* </Link> */}
                {/* {children && (
                    <Icon
                        as={ChevronDownIcon}
                        transition={'all .25s ease-in-out'}
                        transform={isOpen ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                    />
                )} */}
            </Flex>

            <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
                <Stack

                    mt={2}
                    pl={4}
                    borderLeft={1}
                    borderStyle={'solid'}
                    borderColor={useColorModeValue('gray.200', 'gray.700')}
                    align={'start'}>
                    {props.children &&
                        props.children.map((child) => (
                            <Link as={RouterLink} key={child.label} py={2} to={child.to}>
                                {child.label}
                            </Link>

                        ))}
                </Stack>
            </Collapse>
        </Stack>
    );
};


const NAV_ITEMS = [

    {
        label: 'Home',
        to: '/',
    },
    {
        label: 'Activities',
        to: '/activities',
    },
    {
        label: 'My Favorites',
        to: '/myfavorites',
    },
    {
        label: 'My Calendar',
        to: '/myactivities',
    },
    {
        label: 'About the Creator',
        to: '/aboutcreator',
    },
];
